import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MasterDatabaseDisplayModel } from '../../master-database-display.model'
import { MasterCommonServices } from '../../../sections/quotation/master.common.service'
import { AuthStateService } from '../../../auth-state.service'

@Component({
  selector: 'app-master-data-table',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './master-datatable.component.html',
  styleUrls: ['./master-datatable.component.css'],
})
export class DatatableComponent {
  @Input() data: any[] = []
  @Input() columns: MasterDatabaseDisplayModel[] = []
  @Input() title: string = ''
  @Input() addButtonLabel: string = 'Add'
  @Output() add = new EventEmitter<void>()
  @Output() update = new EventEmitter<any>()
  @Output() delete = new EventEmitter<any>()

  // 🔍 Global search
  searchText: string = ''

  // 🎯 Column-based filters
  filters: { [key: string]: string } = {}

  onAdd(): void {
    this.add.emit()
  }

  onUpdate(item: any): void {
    this.update.emit(item)
  }

  onDelete(item: any): void {
    this.delete.emit(item)
  }

  getDropdownLabel(item: string, col: MasterDatabaseDisplayModel): string {
    return col.options?.find((option: any) => option.value === item)?.label || ''
  }

  transformString(str: string): string {
    return str.replace(/\s+/g, '')
  }

  // 🔍 Apply column + global search filters
  filteredData(): any[] {
    return this.data.filter(item => {
      // 1. global search
      const globalMatch = !this.searchText.trim() || this.columns.some(col => {
        if (col.hiddenDataTable) return false
        const value = col.type === 'dropdown'
          ? this.getDropdownLabel(item[col.key], col)
          : item[col.key]
        return value?.toString().toLowerCase().includes(this.searchText.toLowerCase())
      })

      // 2. column filters
      const columnMatch = Object.keys(this.filters).every(key => {
        const filterValue = this.filters[key]?.toLowerCase().trim()
        if (!filterValue) return true
        const col = this.columns.find(c => c.key === key)
        const value = col?.type === 'dropdown'
          ? this.getDropdownLabel(item[key], col!)
          : item[key]
        return value?.toString().toLowerCase().includes(filterValue)
      })

      return globalMatch && columnMatch
    })
  }

  resetFilters(): void {
    this.searchText = ''
    this.filters = {}
  }
}
